module.exports = __webpack_public_path__ + "static/img/box2-config.a725777.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/box2-config.png
// module id = gGKa
// module chunks = 1